// extracted by mini-css-extract-plugin
export default {"mainWrapper":"pageCountHeader_mainWrapper__iB+Hk","content":"pageCountHeader_content__f+3N7","logo":"pageCountHeader_logo__jecCh","count":"pageCountHeader_count__SSOef"};